import React from 'react';

import {

  useNodesState,
  useEdgesState,
  Node,
  Edge,
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import { Bot,} from 'lucide-react';
import ProjectCaseStudy from '../components/ProjectCaseStudy';

const initialNodes: Node[] = [
  {
    id: '1',
    type: 'input',
    data: { label: 'Gmail Email Received' },
    position: { x: 50, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '2',
    data: { label: 'Extract Attachments' },
    position: { x: 250, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '3',
    data: { label: 'Convert Files to Text' },
    position: { x: 450, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '4',
    data: { label: 'GPT Analysis & Detection' },
    position: { x: 650, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '5',
    data: { label: 'Filter Relevant RFQs' },
    position: { x: 150, y: 300 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '6',
    data: { label: 'Generate Report Data' },
    position: { x: 350, y: 300 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '7',
    data: { label: 'Update Google Sheets' },
    position: { x: 550, y: 300 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '8',
    data: { label: 'Prepare Email Package' },
    position: { x: 250, y: 500 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
  {
    id: '9',
    type: 'output',
    data: { label: 'Send to Business Email' },
    position: { x: 450, y: 500 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '600',
      padding: '12px',
      minWidth: '140px',
    },
  },
];

const initialEdges: Edge[] = [
  { id: 'e1-2', source: '1', target: '2', animated: true },
  { id: 'e2-3', source: '2', target: '3', animated: true },
  { id: 'e3-4', source: '3', target: '4', animated: true },
  { id: 'e4-5', source: '4', target: '5', animated: true },
  { id: 'e4-6', source: '4', target: '6', animated: true },
  { id: 'e4-7', source: '4', target: '7', animated: true },
  { id: 'e6-8', source: '6', target: '8', animated: true },
  { id: 'e7-8', source: '7', target: '8', animated: true },
  { id: 'e8-9', source: '8', target: '9', animated: true },
];

const ProjectSeven = () => {
  const [nodes, , onNodesChange] = useNodesState(initialNodes);
  const [edges, , onEdgesChange] = useEdgesState(initialEdges);

  return (
    <ProjectCaseStudy
      title="n8n Email Automation"
      tagline="RFQs extracted from messy email attachments — detected, parsed, reported."
      icon={<Bot className="w-7 h-7" />}
      context="RFQs were buried inside email attachments in every format imaginable. Reviewing each inbox manually meant slow responses and missed deals."
      built="An n8n workflow triggered by Gmail: extracts text from multi-format attachments, uses GPT to detect and structure RFQ content, and logs everything to Google Sheets for live reporting."
      stack={['n8n', 'Gmail API', 'GPT', 'Google Sheets', 'Document parsing']}
      highlights={['Multi-format text extraction', 'Automatic RFQ detection', 'Real-time reporting dashboard']}
      nodes={nodes}
      edges={edges}
      onNodesChange={onNodesChange}
      onEdgesChange={onEdgesChange}
    />
  );
};

export default ProjectSeven;